// import usa_countries from "@/assets/usa_states.json";
import ICountry from "@/models/protocols/ICountry";
import axiosCustom from "@/utils/axiosCustom";

const keyStorage = "wag_regions";

class CountryService {
  private regions: any = [];

  /**
   * Default constructor.
   */
  constructor() {
    this.regions = [];
    this.readFromStorage();
    // eslint-disable-next-line no-console
    console.log("Const Country");
  }

  //   static states(): ICountry[] {
  //     return [...usa_countries] as Array<ICountry>;
  //   }

  //   /**
  //    * Gets all regions for the specific country code.
  //    * @param country_id
  //    */
  //   static async getRegionByCountryAndState(
  //     country_id: string,
  //     state_code: string
  //   ): Promise<any> {
  //     const data = await axiosCustom.get("rest/V1/directory/countries");
  //     const country = data.data.find(r => r.id === country_id);
  //     if (
  //       country &&
  //       country.available_regions &&
  //       country.available_regions.length
  //     ) {
  //       return country.available_regions.find(r => r.code === state_code);
  //     }
  //     return null;
  //   }

  /**
   * Gets all regions
   */
  async getRegions(): Promise<any> {
    if (!this.regions || this.regions.length == 0) {
      const data = await axiosCustom.get("rest/V1/WAG/countries");
      delete data.data["CA"];
      this.regions = data.data;
      window.localStorage.setItem(keyStorage, JSON.stringify(this.regions));
    }
    return this.regions;
  }

  async getTitleByCode(code: string): Promise<string> {
    const regions = await this.getRegions();
    for (const country in regions) {
      const result = regions[country].find((state) => state.short == code);
      if (result) {
        return result.title;
      }
    }
    return "";
  }

  readFromStorage() {
    const val = window.localStorage.getItem(keyStorage) as string;
    if (!val) {
      return;
    }
    const storageObj = JSON.parse(val);
    if (!storageObj) {
      return;
    }

    this.regions = storageObj;
  }
}

const countryService = new CountryService();
export default countryService;
